$(function(){
	if ($('.insights-home').length) {
		$(".insights-home .filter-selected").on('click', function() {

			$('.filter-options').toggleClass('open');
			
		});

        const itemTemplate = ({
            url,
            title,
            service
        }) => `
            <a href="${url}" class="col-span-4 border border-brown p-16 insight-item">
                <span class="label">${service}</span>
                <h3 class="h2 capitalize">${title}</h3>
                <span class="read-more">READ MORE →</span>
            </a>
        `;

        let doReplace = function(data) {
            // let next = $('.next-page');
            $('.filter-options').removeClass('open');
            $('.item-container').html(data.data.map(itemTemplate).join(''));
            // $(next).data('page', data.meta.pagination.current_page);

            // if (data.meta.pagination.total_pages === data.meta.pagination.current_page) {
            //     $(next).hide();
            // } else if (data.meta.pagination.total_pages <= 1) {
            //     $(next).hide();
            // } else {
            //     $(next).show();
            // }

            // if (data.meta.pagination.total == 0) {
            //     $('#noResults').show();
            // } else {
            //     $('#noResults').hide();
            // }     
        }

        // $('.next-page').on('click', function(e) {
        //     e.preventDefault();
        //     let _this = this
        //     let currentPage = $(this).data('page');
        //     let industry = $('#industry').find(":selected").val();
        //     let litigation = $('#litigation').find(":selected").val();
        //     let params = [];
        //     let searchParams = new URLSearchParams(window.location.search);
        //     let type = $('.type-link.active').data('type') ? $('.type-link.active').data('type') : null;

        //     params.push('page=' + (currentPage+1));

        //     if (searchParams.has('litigation')) {
        //         params.push('litigation=' + searchParams.get('litigation'));
        //     } else {
        //         params.push('litigation=' + litigation);
        //     }

        //     if (searchParams.has('industry')) {
        //         params.push('industry=' + searchParams.get('industry'));
        //     } else {
        //         params.push('industry=' + industry);
        //     }

        //     if (type) {
        //         params.push('type=' + type);
        //     }

        //     $.getJSON( "/newsInsights.json?" + params.join('&'), function( data ) {

        //       $('.item-container').append(data.data.map(itemTemplate).join(''));
        //       $(_this).data('page', data.meta.pagination.current_page);
              
        //       if (data.meta.pagination.total_pages === data.meta.pagination.current_page) {
        //         $(_this).hide();
        //       }
        //     });
        // });

        $('.filter-option').click(function(e) {

            e.preventDefault();
            let service = $(this).data('id');
            let params = [];

            if (service) {
                params.push('service=' + service);
            }

            $('.filter-options').removeClass('open');

            $.getJSON( "/insights.json?" + params.join('&'), doReplace);

        });


		$('.view-all').click(function(e) {

            e.preventDefault();
            $.getJSON( "/insights.json", doReplace);

        });
        // $('#industry').change(function(e) {

        //     e.preventDefault();
        //     let industry = $(this).find(":selected").val();
        //     let litigation = $('#litigation').find(":selected").val();
        //     let params = [];
        //     let searchParams = new URLSearchParams(window.location.search);
        //     let type = $('.type-link.active').data('type') ? $('.type-link.active').data('type') : null;

        //     params.push('industry=' + industry);

        //     if (searchParams.has('litigation')) {
        //         params.push('litigation=' + searchParams.get('litigation'));
        //     } else {
        //         params.push('litigation=' + litigation);
        //     }

        //      if (searchParams.has('page')) {
        //         params.push('page=' + searchParams.get('page'));
        //     }

        //     if (type) {
        //         params.push('type=' + type);
        //     }

        //     $.getJSON( "/newsInsights.json?" + params.join('&'), doReplace);

        // });

        // $('.type-link').on('click', function(e) {
        //     e.preventDefault();

        //     let _this = this
        //     let industry = $('#industry').find(":selected").val();
        //     let litigation = $('#litigation').find(":selected").val();
        //     let params = [];
        //     let searchParams = new URLSearchParams(window.location.search);
        //     let type = $(this).data('type');

        //     if (type == "all") {
        //         $('.type-link').removeClass('active');
        //         $("#litigation option:selected").prop("selected", false);
        //         $("#industry option:selected").prop("selected", false);
        //     } else {
        //         if ($(_this).hasClass('active')) {
        //             // Remove type
        //             $('.type-link').removeClass('active');
        //         } else {
        //             params.push('type=' + type);
        //             $('.type-link').removeClass('active');
        //             $(_this).addClass('active');
        //         }

        //         if (searchParams.has('litigation')) {
        //             params.push('litigation=' + searchParams.get('litigation'));
        //         } else {
        //             params.push('litigation=' + litigation);
        //         }

        //         if (searchParams.has('industry')) {
        //             params.push('industry=' + searchParams.get('industry'));
        //         } else {
        //             params.push('industry=' + industry);
        //         }
        //     }

            

        //     $.getJSON( "/newsInsights.json?" + params.join('&'), doReplace);
        // });
    }
});